// extracted by mini-css-extract-plugin
module.exports = {"trending_wrapper":"xciRh","sliderHeading":"rwKrk","trending_wrapper_main":"B3Kuv","sliderItem":"c5HdF","sliderItemLink":"FANDV","sliderItemHeading":"IPqTy"};